import Constants from '../../utils/Constants';
import { ClubHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const getGroupFacilitiesUsasClubIdData = (usasClubId, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      usasClubId,
      orgUnitId: '',
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const usasClubIdForUrl = usasClubId ? encodeURIComponent(usasClubId) : 'NaN';
    const url = `/UsasClub/${usasClubIdForUrl}/facilityLinks`;
    ClubHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const options = arrayData.map((facility) => {
            return { id: facility.facilityId, name: facility.facility?.facilityName };
          });
          options.unshift({ id: Constants.DEFAULT_ID, name: '--' });

          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            options,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};


export default getGroupFacilitiesUsasClubIdData;